/**
 * created by lei lei
 *关联任务
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Row, Col,} from "antd";
import  './Rwlation.css'
import {Scrollbars} from "react-custom-scrollbars";
import task from './img/task.png'
import task2 from './img/task2.png'
import SpacerBlock from "../spacerBlock/SpacerBlock";
import * as utils from '../../../utils/index';
import *as actions from "../../../actions/manuscriptPool"

export default class RelationTaskDetail extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions=actions;
        this.state = {
            taskVisible: false,
            type:2,
            data:{}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    taskDetailShow(data){
        console.log(data)
        this.getTaskDetail(data)
       // this.setState({taskVisible:true,data})
    }
    getTaskDetail(data){
        let body={
            interviewId:data,
        };
            this.actions.interviewGetById(body,data=>{
                this.setState({taskVisible:true,data})
            })
    }

    render() {
        let data=this.state.data;
        let projectName=[];
        data.eventItem&&data.eventItem.forEach((item,index)=>{
            projectName.push(item.name)
        });
        return (
            <div>
                <Modal
                    title={'任务信息'}
                    visible={this.state.taskVisible}
                    onOk={() => {

                    }}
                    okText={'确认选择'}
                    cancelText={'取消关联'}
                    width={1000}
                    bodyStyle={{padding: 0}}
                    onCancel={() => {
                        this.setState({taskVisible: false})
                    }}
                    footer={null}
                >

                    <div style={{height: '65vh', padding: 20}} className={'Relation'}>
                        <Scrollbars>
                            <div style={{fontSize:16,fontWeight:'bold',color: '#6c748b',paddingBottom:20}}>
                                <img src={this.state.data.leixing==='新闻报道'?task:task2} alt=""/>&nbsp;{this.state.data.leixing==='新闻报道'?'新闻报道':'选题策划'}
                                <div style={{marginTop:20}}>
                                    <SpacerBlock height={1}/>
                                </div>
                            </div>
                        <Row>
                            <Col span={8} className={'title'}><div>任务名称</div></Col>
                            <Col span={8} className={'title'}><div>所属项目</div></Col>
                            <Col span={8} className={'title'}><div>活动时间</div></Col>
                        </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={8}><div className={'content'} >{data.title}</div></Col>
                                <Col span={8}><div className={'content'}  title={projectName.join(',')}>{projectName.join(',')}</div></Col>
                                <Col span={8}><div className={'content'} >{data.interviewDate&&data.interviewDate.time?utils.formatDate(data.interviewDate.time):''}</div></Col>
                            </Row>
                        <div >
                            <Row style={{marginTop: 20}}>
                                <Col span={8} className={'title'}><div>活动地点</div></Col>
                                <Col span={8} className={'title'}><div>回稿时间</div></Col>
                                <Col span={8} className={'title'}><div>主办单位</div></Col>
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={8}><div className={'content'} >{data.place}</div></Col>
                                <Col span={8}><div className={'content'} >{data.endDate&&data.endDate.time?utils.formatDate(data.endDate.time):''}</div></Col>
                                <Col span={8}><div className={'content'} >{data.sponsor}</div></Col>
                            </Row>
                        </div>
                        <div>
                            <Row  style={{marginTop: 20}}>
                                <Col span={8} className={'title'}><div>活动联系人</div></Col>
                                <Col span={8} className={'title'}><div>联系方式</div></Col>
                            </Row>
                            <Row  style={{marginTop: 10}}>
                                <Col span={8}><div className={'content'} >{data.contacts}</div></Col>
                                <Col span={8}><div className={'content'} >{data.contactsWay}</div></Col>
                            </Row>
                        </div>
                        <div className={'title'} style={{marginTop: 20}}>任务内容:</div>
                        <div  style={{marginTop: 10 ,fontSize:16,color: '#808eb5'}}>
                            {data.content} </div>
                        </Scrollbars>
                    </div>
                </Modal>
            </div>
        )
    }

}